import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Process from './components/Process';
import Contact from './components/Contact';
import Footer from './components/Footer';
import QuoteModal from './components/modals/QuoteModal';
import AdminLoginModal from './components/modals/AdminLoginModal';
import NetworkStatus from './components/NetworkStatus';
import EzemsStory from './components/EzemsStory';

function App() {
    const [quoteModalOpen, setQuoteModalOpen] = useState(false);
    const [adminModalOpen, setAdminModalOpen] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showStory, setShowStory] = useState(false);

    // ── Check hash on mount (after full render) ──────────────────────────────
    useEffect(() => {
        const hash = window.location.hash;
        if (hash === '#our-story' || hash === '#our-story/') {
            setShowStory(true);
        }
    }, []);

    // ── Scroll into view after showStory becomes true ────────────────────────
    useEffect(() => {
        if (!showStory) return;
        // Double RAF ensures the section is painted before we scroll
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const el = document.getElementById('our-story');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            });
        });
    }, [showStory]);

    // ── Handle hash changes (back / forward / in-page nav) ───────────────────
    useEffect(() => {
        const onHashChange = () => {
            if (window.location.hash === '#our-story') {
                setShowStory(true);
            }
        };
        window.addEventListener('hashchange', onHashChange);
        return () => window.removeEventListener('hashchange', onHashChange);
    }, []);

    // ── Security listeners ───────────────────────────────────────────────────
    useEffect(() => {
        const handleContextMenu = (e) => e.preventDefault();
        const handleKeydown = (e) => {
            if (
                e.keyCode === 123 ||
                (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) ||
                (e.ctrlKey && e.keyCode === 85) ||
                (e.ctrlKey && e.keyCode === 83)
            ) {
                e.preventDefault();
                return false;
            }
        };
        const handleBlur  = () => document.body.classList.add('window-blurred');
        const handleFocus = () => document.body.classList.remove('window-blurred');

        document.addEventListener('contextmenu', handleContextMenu);
        document.addEventListener('keydown', handleKeydown);
        window.addEventListener('blur', handleBlur);
        window.addEventListener('focus', handleFocus);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('keydown', handleKeydown);
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    const handleOpenStory = () => {
        setShowStory(true);
        window.history.pushState(null, '', '/#our-story');
    };

    return (
        <div className="antialiased">
            <Navbar
                onOpenQuote={() => setQuoteModalOpen(true)}
                onOpenStory={handleOpenStory}
            />
            <Hero onOpenQuote={() => setQuoteModalOpen(true)} />
            <Services />
            <Portfolio isAdmin={isAdmin} />
            <Process />
            <Contact />

            {/*
                Always rendered in the DOM — hidden with CSS until triggered.
                This ensures id="our-story" always exists for hash navigation.
            */}
            <section
                id="our-story"
                aria-hidden={!showStory}
                style={{
                    display: showStory ? 'block' : 'none',
                    visibility: showStory ? 'visible' : 'hidden',
                    height: showStory ? 'auto' : 0,
                    overflow: showStory ? 'visible' : 'hidden',
                }}
            >
                <EzemsStory />
            </section>

            <Footer isAdmin={isAdmin} onAdminClick={() => setAdminModalOpen(true)} onOpenStory={handleOpenStory} />

            <QuoteModal isOpen={quoteModalOpen} onClose={() => setQuoteModalOpen(false)} />
            <AdminLoginModal
                isOpen={adminModalOpen}
                onClose={() => setAdminModalOpen(false)}
                onLogin={setIsAdmin}
            />
            <NetworkStatus />
        </div>
    );
}

export default App;